// extracted by mini-css-extract-plugin
export default {"container":"ComboboxTruong_container__bTLdm","school":"ComboboxTruong_school__tjbv2","logo":"ComboboxTruong_logo__jEotd","name":"ComboboxTruong_name__gNDsB"};